export default __webpack_public_path__ + "static/logo-9c6ecee095d5ddd4c6fdcfeeb1170fea.png";